import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import { tenantSettingsAPI } from '@/providers/apis/tenant-settings/tenant-settings';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import CourseContentVisibility from './course-content-visibility/course-content-visibility';
import CustomNotifications from './custom-notifications/custom-notifications';
import DefaultClassCourseContentVisibility from './default-class-course-content-visibility/default-class-course-content-visibility';
import DefaultViewFwLevel from './default-view-fw-level/default-view-fw-level';
import DiagnosticPercentageScore from './diagnostic-percentage-score/diagnostic-percentage-score';
import MasteryContentCompletion from './mastery-content-completion/mastery-content-completion';
import ToggleSwitch from './toggle-switch/toggle-switch';
import TranslationSetting from './translation-setting/translation-setting';

@Component({
    name: 'white-labeling-settings',
    components: {
        'material-icons': GoogleMaterialIcon,
        'toggle-switch': ToggleSwitch,
        'translation-setting': TranslationSetting,
        'diagnostic-percentage-score': DiagnosticPercentageScore,
        'course-content-visibility': CourseContentVisibility,
        'default-view-fw-level': DefaultViewFwLevel,
        'mastery-content-completion': MasteryContentCompletion,
        'custom-notifications': CustomNotifications,
        'default-class-course-content-visibility': DefaultClassCourseContentVisibility,
    },
})

export default class WhiteLabelingSettings extends Vue {


    @Prop()
    private activeComponent!: string;

    @Prop()
    private selectedConfig: any;

    @Prop()
    private tenantSettings: any;

    private selectedLevel: string = 'categoryLists';

    private selectItem: string = '';

    private contentLoader: any = [];

    @Watch('selectedConfig', { deep: true })
    private watchSelectedConfig(value: any) {
        this.contentLoader = [];
        this.selectItem = 'K12.MA';
        this.loadContent();
    }

    private created() {
        this.loadContent();
    }


    // -------------------------------------------------------------------------------
    // Actions

    private onChangeConfig(config: any) {
        this.$emit('onChangeConfig', config);
    }


    // --------------------------------------------------------------------------------
    // Methods

    private loadContent() {
        const component: any = this;
        if (this.selectedConfig && this.selectedConfig.action) {
            component[`${this.selectedConfig.action}`]();
        }
    }

    private categoryLists() {
        taxonomyAPI.fetchTaxonomyClassifications().then((classification: any) => {
            const subClassification = this.tenantSettings.find((item: any) => item.key === 'tx_sub_classifier_prefs');
            if (subClassification && subClassification.value.ids) {
                const categoryIds = subClassification.value.ids;
                classification = classification.filter((item: any) => categoryIds.indexOf(item.id) !== -1);
            }
            this.contentLoader = classification;
            });

    }

}
